/* eslint-disable no-use-before-define */
import {
  AccountBalanceRounded,
  AccountBalanceWalletRounded,
  AlternateEmailRounded,
  ArchiveRounded,
  AssignmentIndRounded,
  AssignmentRounded,
  AtmRounded,
  BarChartRounded,
  BuildCircleRounded,
  BuildRounded,
  CommuteRounded,
  ContactPageRounded,
  ContactSupportRounded,
  DarkModeRounded,
  DomainRounded,
  EmailRounded,
  EmojiTransportationRounded,
  EnergySavingsLeafRounded,
  FactCheckRounded,
  Folder,
  GradientOutlined,
  GroupWork,
  GroupWorkRounded,
  HistoryEduRounded,
  Home,
  HomeRounded,
  HowToVoteRounded,
  InboxRounded,
  InputRounded,
  LibraryBooks,
  LightModeRounded,
  LocalFireDepartmentRounded,
  LocalShippingRounded,
  LocationCityRounded,
  MapRounded,
  MenuBookRounded,
  MoneyRounded,
  MovieFilterRounded,
  NaturePeopleRounded,
  PhotoSizeSelectLargeRounded,
  PortraitRounded,
  ReceiptLongRounded,
  RssFeedRounded,
  SchoolRounded,
  SecurityRounded,
  SendRounded,
  SettingsRounded,
  ShoppingCartRounded,
  SummarizeRounded,
  SupervisedUserCircleRounded,
  TextDecreaseRounded,
  TextIncreaseRounded,
  TimelapseRounded,
  TimelineTwoTone,
  TuneRounded,
  VerifiedUserRounded,
  WorkspacePremiumRounded,
} from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Drawer,
  List,
  Popover,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { alpha } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { matchPath, useLocation } from "react-router-dom";
import Hidden from "src/components/Hidden";
import { TEXT_SCALES, THEMES } from "src/constants";
import { media_url } from "src/coreConfig";
import { setCurrentApp } from "src/slices/customers";
import { saveSettings } from "src/slices/settings";
import { checkPermission } from "src/slices/users";
import { useDispatch, useSelector } from "src/store";
import PaymentAccounts from "src/views/arkadu/accounts/parts/PaymentAccounts";
import NavItem from "./NavItem";

const drawerWidth = 276;

const NAVICONS = {
  home: HomeRounded,
  layout: LocationCityRounded,
  clipboard: AssignmentRounded,
  briefcaseIcon: AccountBalanceRounded,
  shoppingCartIcon: AccountBalanceWalletRounded,
  support: ContactSupportRounded,
  civil: AssignmentIndRounded,
  map: MapRounded,
  cash: MoneyRounded,
  cartIcon: CommuteRounded,
  urban: DomainRounded,
  urbin: DomainRounded,
  adsIcon: MovieFilterRounded,
  eco: EnergySavingsLeafRounded,
  fireDepartment: LocalFireDepartmentRounded,
  email: AlternateEmailRounded,
  bank: AtmRounded,
  localShipping: LocalShippingRounded,
  tuneIcon: TuneRounded,
  erp: GroupWorkRounded,
  archive: ArchiveRounded,
  menuBook: MenuBookRounded,
  groupWork: GroupWork,
  pollIcon: HowToVoteRounded,
  timelineTwoTone: TimelineTwoTone,
  input: InputRounded,
  timelapse: TimelapseRounded,
  security: SecurityRounded,
  barChart: BarChartRounded,
  libraryBooks: LibraryBooks,
  ads: GradientOutlined,
  photoSize: PhotoSizeSelectLargeRounded,
  shoppingCart: ShoppingCartRounded,
  developerBoard: BuildCircleRounded,
  socialResp: NaturePeopleRounded,
  audit: VerifiedUserRounded,
  emailRounded: EmailRounded,
  emailInbox: InboxRounded,
  emailSend: SendRounded,
  informalEconomy: ContactPageRounded,
  rss_feed: RssFeedRounded,
  requestPage: SummarizeRounded,
  invoice: ReceiptLongRounded,
  documents: Folder,
  classroom: SchoolRounded,
  signature: HistoryEduRounded,
  certificate: WorkspacePremiumRounded,
  approval: FactCheckRounded,
};
function renderNavItems({
  items,
  pathname = "",
  currentCustomer,
  admin,
  navTone,
  depth = 0,
}) {
  return (
    <List
      disablePadding
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: navTone === "dense-pro" ? 0.06 : 0.18,
      }}
    >
      {items && items.length > 0
        ? items.reduce(
            (acc, item) =>
              reduceChildRoutes({
                acc,
                item,
                pathname,
                currentCustomer,
                depth,
                admin,
                navTone,
              }),
            [],
          )
        : null}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname = "",
  item,
  depth,
  currentCustomer,
  admin,
  navTone,
}) {
  const key = item.title + depth;
  const isPublic = item.public ?? item.is_public;
  let base = "";
  if (currentCustomer) {
    base = `/${currentCustomer.shortname}`;

    // if (admin) {
    //   base = `${base}/`;
    // }
  }
  var moduleTitle =
    currentCustomer?.arkadu_modules?.find((m) => m.name === item.module_name)
      ?.verbose_name || item.title;

  const href =
    typeof item.href === "string"
      ? base
        ? `${base}${item.href}`
        : item.href
      : null;
  if (item.items) {
    const open =
      typeof href === "string" && href.length > 0
        ? matchPath(
            {
              path: href,
              end: false,
            },
            pathname,
          )
        : false;
    if (isPublic || admin) {
      acc.push(
        <NavItem
          depth={depth}
          icon={NAVICONS[item.icon] || NAVICONS.libraryBooks}
          info={item.info}
          key={key}
          open={Boolean(open)}
          title={moduleTitle}
          variant={navTone}
        >
          {renderNavItems({
            depth: depth + 1,
            pathname,
            items: item.items,
            currentCustomer: currentCustomer,
            admin: admin,
            navTone,
          })}
        </NavItem>,
      );
    }
  } else {
    if (isPublic || admin) {
      acc.push(
        <NavItem
          depth={depth}
          href={href}
          icon={NAVICONS[item.icon] || NAVICONS.libraryBooks}
          info={item.info}
          key={key}
          title={moduleTitle}
          variant={navTone}
        />,
      );
    }
  }

  return acc;
}

const NavBar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const { user } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const settings = useSelector((state) => state.settings);

  const [adminSections, setAdminSections] = useState([]);
  const [paymentAnchor, setPaymentAnchor] = useState(null);
  const [customerStoriesMeta, setCustomerStoriesMeta] = useState({
    hasStories: false,
    count: 0,
  });
  const { currentCustomer, customerSections, currentApp } = useSelector(
    (state) => state.customers,
  );
  const { sections, adminMode } = settings;
  const pathname = location.pathname;
  const isRegistrationPath = pathname.includes("account/registration");
  useCallback(() => {}, [sections]);
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    if (currentCustomer && customerSections) {
      if (
        !currentApp ||
        !location.pathname.includes(
          `/${currentCustomer.shortname}/${currentApp.href}/`,
        )
      ) {
        var cA = null;
        customerSections.forEach((_cS) => {
          if (
            location.pathname.includes(
              `/${currentCustomer.shortname}${_cS.href}`,
            )
          ) {
            cA = _cS;
          }
        });
        if ((cA && cA.href) !== (currentApp && currentApp.href)) {
          dispatch(setCurrentApp(cA));
        }
      }
    }
  }, [currentCustomer, customerSections, location.pathname, currentApp]);

  useEffect(() => {}, [sections, currentCustomer]);

  useEffect(() => {
    const handleStoriesMeta = (event) => {
      const hasStories = Boolean(event?.detail?.hasStories);
      const count = Number(event?.detail?.count || 0);
      setCustomerStoriesMeta({
        hasStories,
        count: Number.isFinite(count) ? count : 0,
      });
    };

    window.addEventListener("arkadu-customer-stories-state", handleStoriesMeta);
    return () => {
      window.removeEventListener(
        "arkadu-customer-stories-state",
        handleStoriesMeta,
      );
    };
  }, []);

  const UserSections = [
    {
      subheader: "Perfil",
      items: [
        {
          title: "Mi Portafolio",
          icon: Folder,
          color: "secondary",
          href: "/app/reports/dashboard",
          items: [
            {
              title: "Basic Data",
              href: "/app/account/general",
              icon: <VerifiedUserRounded />,
            },
            {
              title: "Identities",
              href: "/app/account/identities",
              icon: PortraitRounded,
            },
            {
              title: "Address",
              href: "/app/account/addresses",
              icon: MapRounded,
            },
            {
              title: "Companies",
              href: "/app/account/companies",
              icon: BuildRounded,
            },
            {
              title: "Vehicles",
              href: "/app/account/vehicles",
              icon: EmojiTransportationRounded,
            },
            // { title: 'RealEstates', href: '/app/account/vehicles', icon: Home },
          ],
        },
      ],
    },
  ];

  const loadAdminSections = () => {
    var _admSections = [];
    // if (
    //   checkPermission({
    //     action: "can_view_stats",
    //     module: "nets_customers",
    //     user: user,
    //     customerId: currentCustomer.id,
    //   })
    // ) {
    //   _admSections.push({
    //     title: t("Reportes"),
    //     icon: "barChart",
    //     href: `/AdminDashboard/`,
    //     target: "_bank",
    //   });
    // }
    _admSections.push({
      title: t("Configuración"),
      color: "secondary",
      icon: SettingsRounded,
      href: `/${currentCustomer.shortname}/corporateAdmin/`,
      items: [
        {
          title: t("Corporativo"),
          icon: SupervisedUserCircleRounded,
          color: "secondary",
          href: `/corporateAdmin/`,
        },
      ],
    });
    setAdminSections(_admSections);
  };

  useEffect(() => {
    if (
      user &&
      currentCustomer &&
      settings.adminMode &&
      checkPermission({
        action: "can_view_user",
        module: "nets_user",
        user: user,
        customerId: currentCustomer.id,
      })
    ) {
      loadAdminSections();
    }
  }, [currentCustomer, user, settings]);

  // useEffect(() => {
  //   if (!user) {
  //     dispatch(loadUserFromStorage());
  //   }
  // }, [user]);

  if (!user) {
    return null;
  }

  const isDense = settings.textScale <= TEXT_SCALES.NORMAL;
  const navTone = isDense ? "dense-pro" : "premium-clean";

  const content = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",

        backgroundColor: (theme) =>
          settings.adminMode
            ? theme.palette.mode === "dark"
              ? alpha(
                  theme.palette.navbar?.dark ?? theme.palette.background.dark,
                  0.95,
                )
              : alpha(theme.palette.navbar?.main ?? "#f8faff", 0.2)
            : theme.palette.mode === "dark"
              ? alpha(
                  theme.palette.navbar?.dark ?? theme.palette.background.paper,
                  0.98,
                )
              : alpha(
                  theme.palette.navbar?.main ??
                    theme.palette.background.default,
                  0.42,
                ),
      }}
    >
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 3,
            px: isDense ? 1 : 1.5,
            pt: isDense ? 1 : 1.5,
            pb: isDense ? 0.85 : 1.1,
            borderBottom: "1px solid",
            borderColor: (theme) =>
              settings.adminMode
                ? theme.palette.mode === "dark"
                  ? alpha(theme.palette.common.white, 0.18)
                  : "#dbe4ff"
                : theme.palette.divider,
            backdropFilter: "blur(10px)",
            bgcolor: (theme) =>
              theme.palette.mode === "dark"
                ? alpha(theme.palette.background.default, 0.96)
                : alpha(theme.palette.background.default, 0.88),
          }}
        >
          <Box
            sx={{
              p: isDense ? 0.8 : 1.1,
              borderRadius: isDense ? 2 : 2.5,
              border: "1px solid",
              borderColor: (theme) =>
                settings.adminMode
                  ? theme.palette.mode === "dark"
                    ? alpha(theme.palette.common.white, 0.18)
                    : "#dbe4ff"
                  : theme.palette.divider,
              bgcolor: (theme) =>
                theme.palette.mode === "dark"
                  ? alpha(theme.palette.background.paper, 0.82)
                  : alpha(theme.palette.background.paper, 0.92),
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: isDense ? 0.75 : 1,
                px: 0.5,
                pb: isDense ? 0.75 : 1,
              }}
            >
              {currentCustomer?.icon ? (
                <Box
                  onClick={() => {
                    if (!customerStoriesMeta.hasStories) {
                      return;
                    }
                    window.dispatchEvent(
                      new CustomEvent("arkadu-open-customer-stories", {
                        detail: { index: 0, source: "navbar-logo" },
                      }),
                    );
                  }}
                  sx={{
                    p: customerStoriesMeta.hasStories ? 0.22 : 0,
                    borderRadius: 1.35,
                    border: customerStoriesMeta.hasStories
                      ? "2px solid"
                      : "2px solid transparent",
                    borderColor: customerStoriesMeta.hasStories
                      ? "primary.main"
                      : "transparent",
                    cursor: customerStoriesMeta.hasStories
                      ? "pointer"
                      : "default",
                    position: "relative",
                  }}
                >
                  <Avatar
                    src={media_url(currentCustomer.icon)}
                    variant="rounded"
                    sx={{
                      width: isDense ? 34 : 38,
                      height: isDense ? 34 : 38,
                      borderRadius: 1.25,
                      flexShrink: 0,
                    }}
                    alt={currentCustomer.name}
                  />
                  {customerStoriesMeta.hasStories && (
                    <Box
                      sx={{
                        position: "absolute",
                        right: -5,
                        top: -5,
                        minWidth: 16,
                        height: 16,
                        px: 0.4,
                        borderRadius: 99,
                        bgcolor: "primary.main",
                        color: "primary.contrastText",
                        fontSize: "0.55rem",
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {customerStoriesMeta.count}
                    </Box>
                  )}
                </Box>
              ) : null}
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  noWrap
                  sx={{
                    color: "text.secondary",
                    color: (theme) =>
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.common.white, 0.78)
                        : theme.palette.secondary.main,
                    letterSpacing: 0.9,
                    lineHeight: 1.1,
                    display: "block",
                    fontWeight: 700,
                    fontSize: isDense ? "0.65rem" : "0.72rem",
                  }}
                >
                  {currentCustomer?.name || t("Mi espacio")}
                </Typography>
                <Typography
                  variant="body1"
                  noWrap
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.common.white, 0.96)
                        : theme.palette.text.primary,
                    lineHeight: 1.2,
                    fontWeight: 700,
                    fontSize: isDense ? "0.95rem" : "1rem",
                  }}
                >
                  {currentApp?.title || t("Panel principal")}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{ display: "flex", alignItems: "center", gap: 0.4, px: 0.5 }}
            >
              <Tooltip title={t("Reducir texto")}>
                <span>
                  <IconButton
                    size="small"
                    disabled={settings.textScale <= TEXT_SCALES.NORMAL}
                    onClick={() =>
                      dispatch(
                        saveSettings({
                          textScale:
                            settings.textScale >= TEXT_SCALES.XLARGE
                              ? TEXT_SCALES.LARGE
                              : TEXT_SCALES.NORMAL,
                        }),
                      )
                    }
                    aria-label="Reducir texto"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? alpha(theme.palette.common.white, 0.86)
                          : theme.palette.text.secondary,
                      "&:hover": {
                        bgcolor: (theme) =>
                          theme.palette.mode === "dark"
                            ? alpha(theme.palette.primary.main, 0.14)
                            : "#eef2ff",
                        color: (theme) =>
                          theme.palette.mode === "dark"
                            ? alpha(theme.palette.common.white, 0.98)
                            : theme.palette.primary.main,
                      },
                      "&.Mui-disabled": {
                        color: (theme) =>
                          alpha(theme.palette.text.primary, 0.28),
                      },
                    }}
                  >
                    <TextDecreaseRounded fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={t("Ampliar texto")}>
                <span>
                  <IconButton
                    size="small"
                    disabled={settings.textScale >= TEXT_SCALES.XLARGE}
                    onClick={() =>
                      dispatch(
                        saveSettings({
                          textScale:
                            settings.textScale <= TEXT_SCALES.NORMAL
                              ? TEXT_SCALES.LARGE
                              : TEXT_SCALES.XLARGE,
                        }),
                      )
                    }
                    aria-label="Ampliar texto"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? alpha(theme.palette.common.white, 0.9)
                          : theme.palette.primary.main,
                      "&:hover": {
                        bgcolor: (theme) =>
                          theme.palette.mode === "dark"
                            ? alpha(theme.palette.primary.main, 0.14)
                            : "#eef2ff",
                        color: (theme) =>
                          theme.palette.mode === "dark"
                            ? alpha(theme.palette.common.white, 0.98)
                            : "#3730a3",
                      },
                      "&.Mui-disabled": {
                        color: (theme) =>
                          alpha(theme.palette.text.primary, 0.28),
                      },
                    }}
                  >
                    <TextIncreaseRounded fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
              <Box sx={{ flexGrow: 1 }} />
              <Tooltip
                title={
                  settings.theme === THEMES.DARK
                    ? t("Modo claro")
                    : t("Modo oscuro")
                }
              >
                <IconButton
                  size="small"
                  onClick={() =>
                    dispatch(
                      saveSettings({
                        theme:
                          settings.theme === THEMES.DARK
                            ? THEMES.LIGHT
                            : THEMES.DARK,
                      }),
                    )
                  }
                  aria-label="toggle theme"
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.common.white, 0.92)
                        : theme.palette.primary.main,
                  }}
                >
                  {settings.theme === THEMES.DARK ? (
                    <LightModeRounded fontSize="small" />
                  ) : (
                    <DarkModeRounded fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
            </Box>

            {currentCustomer?.accounts && (
              <>
                <Button
                  size="small"
                  variant="text"
                  fullWidth
                  startIcon={<MoneyRounded fontSize="small" />}
                  onClick={(e) => setPaymentAnchor(e.currentTarget)}
                  sx={{
                    mt: isDense ? 0.4 : 0.6,
                    justifyContent: "flex-start",
                    color: (theme) =>
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.common.white, 0.9)
                        : theme.palette.primary.main,
                    fontSize: isDense ? "0.68rem" : "0.73rem",
                    fontWeight: 700,
                    borderRadius: 2,
                    textTransform: "none",
                    border: (theme) =>
                      `1px solid ${alpha(
                        theme.palette.primary.main,
                        theme.palette.mode === "dark" ? 0.45 : 0.18,
                      )}`,
                    bgcolor: (theme) =>
                      theme.palette.mode === "dark"
                        ? alpha(theme.palette.primary.main, 0.08)
                        : alpha(theme.palette.primary.main, 0.04),
                    "&:hover": {
                      bgcolor: (theme) =>
                        theme.palette.mode === "dark"
                          ? alpha(theme.palette.primary.main, 0.2)
                          : alpha(theme.palette.primary.main, 0.1),
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? alpha(theme.palette.common.white, 0.98)
                          : "#3730a3",
                    },
                  }}
                >
                  {t("¿Dónde Pagar?")}
                </Button>
                <Popover
                  open={Boolean(paymentAnchor)}
                  anchorEl={paymentAnchor}
                  onClose={() => setPaymentAnchor(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  slotProps={{
                    paper: {
                      sx: (theme) => ({
                        width: 360,
                        maxWidth: "92vw",
                        maxHeight: "min(70vh, 560px)",
                        overflowY: "auto",
                        p: 1.5,
                        bgcolor:
                          theme.palette.mode === "dark"
                            ? alpha(theme.palette.background.paper, 0.98)
                            : theme.palette.background.paper,
                        border: `1px solid ${alpha(
                          theme.palette.divider,
                          theme.palette.mode === "dark" ? 0.75 : 1,
                        )}`,
                        boxShadow:
                          theme.palette.mode === "dark"
                            ? "0 20px 48px rgba(0,0,0,0.42)"
                            : theme.shadows[8],
                      }),
                    },
                  }}
                >
                  <PaymentAccounts />
                </Popover>
              </>
            )}

            <Box sx={{ mt: isDense ? 0.55 : 0.8, px: 0.5 }} />
          </Box>

          <Box
            sx={{
              mt: isDense ? 0.7 : 1,
              borderTop: "1px dashed",
              borderColor: (theme) =>
                settings.adminMode
                  ? theme.palette.mode === "dark"
                    ? alpha(theme.palette.common.white, 0.16)
                    : "#e2e8f0"
                  : theme.palette.divider,
              pt: isDense ? 0.55 : 0.8,
            }}
          >
            <NavItem
              depth={0}
              href={`/app/account`}
              icon={() => (
                <Avatar
                  alt="User"
                  src={user.avatar}
                  sx={{ width: 24, height: 24 }}
                />
              )}
              key="u-pro"
              title={`${user.fullname}`}
              variant={navTone}
            />
            <NavItem
              depth={0}
              href={`/app/notify/`}
              icon={EmailRounded}
              title={t("Buzón de entrada")}
              variant={navTone}
              info={
                user.notifications_count
                  ? () => (
                      <Badge
                        badgeContent={user.notifications_count}
                        sx={{
                          "& .MuiBadge-badge": {
                            bgcolor: "#dc2626",
                            color: "#fff",
                            fontWeight: 700,
                          },
                        }}
                      />
                    )
                  : null
              }
            />
          </Box>
        </Box>

        <Box sx={{ px: isDense ? 0.9 : 1.25, py: isDense ? 0.85 : 1.1 }}>
          {currentCustomer && customerSections.length > 0 && (
            <List
              disablePadding
              sx={{
                p: isDense ? 0.2 : 0.35,
                borderRadius: 0,
                border: "none",
                bgcolor: "transparent",
              }}
            >
              <List
                disablePadding
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: isDense ? 0.04 : 0.12,
                }}
              >
                {/* <ListItem>
                  <Button href={`/${currentCustomer.shortname}`}>
                    {currentCustomer.shortname.toLocaleUpperCase()}
                  </Button>
                </ListItem> */}
                <NavItem
                  depth={0}
                  icon={Home}
                  // icon={() => (
                  //   <Avatar
                  //     alt={currentCustomer.name}
                  //     src={media_url(currentCustomer.icon)}
                  //     style={{ paddingLeft: "-5px", marginRight: "6px" }}
                  //   />
                  // )}
                  href={`/${currentCustomer.shortname}`}
                  title={t("Inicio")}
                  variant={navTone}
                />
              </List>
              <List
                disablePadding
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: isDense ? 0.04 : 0.12,
                }}
              >
                {adminSections.length > 0 &&
                  renderNavItems({
                    items: adminSections,
                    pathname: location.pathname,
                    currentCustomer: currentCustomer,
                    admin: adminMode,
                    navTone,
                  })}
                {renderNavItems({
                  items: customerSections,
                  pathname: location.pathname,
                  currentCustomer: currentCustomer,
                  admin: adminMode,
                  navTone,
                })}
              </List>
            </List>
          )}

          {UserSections.map((section) => {
            return (
              <List
                key={section.subheader}
                disablePadding
                sx={{ mt: isDense ? 0.3 : 0.45 }}
              >
                {renderNavItems({
                  items: section.items,
                  pathname: location.pathname,
                  navTone,
                })}
              </List>
            );
          })}
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              borderRight: "1px solid",
              borderColor: "divider",
              backgroundColor: "background.paper",
              boxShadow: (theme) =>
                `18px 0 40px ${alpha(
                  theme.palette.common.black,
                  theme.palette.mode === "dark" ? 0.28 : 0.08,
                )}`,
            },
          }}
        >
          {location.pathname.endsWith("/registration") ? null : content}
        </Drawer>
      </Hidden>
      {isRegistrationPath ? null : (
        <Hidden lgDown>
          <Drawer
            anchor="left"
            open
            variant="persistent"
            sx={{
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                borderRight: "1px solid",
                borderColor: "divider",
                backgroundColor: "background.paper",
                boxShadow: (theme) =>
                  `18px 0 40px ${alpha(
                    theme.palette.common.black,
                    theme.palette.mode === "dark" ? 0.28 : 0.08,
                  )}`,
              },
            }}
          >
            {location.pathname.endsWith("/registration") ? null : content}
          </Drawer>
        </Hidden>
      )}
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};
export { NAVICONS };
export default NavBar;
